import React from "react";
import PropTypes from "prop-types";
import DraggableList from "react-draggable-list";

class DraggableButtons extends React.Component {
  constructor() {
    super();
    this.setContainer = this.setContainer.bind(this);
  }

  setContainer(el) {
    this._container = el;
  }

  render() {
    return (
      <div style={{ overflow: "hidden", paddingBottom: "10px" }} ref={this.setContainer}>
        {this.props.children}
        <DraggableList
          itemKey="name"
          template={DraggableButton}
          list={this.props.list}
          commonProps={this.props}
          onMoveEnd={this.props.onListChange}
          container={() => this._container}
        />
      </div>
    );
  }
}

export default DraggableButtons;
DraggableButtons.propTypes = {
  height: PropTypes.string.isRequired, // eslint-disable-line
  onListChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.any]),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number
    })
  )
};

class DraggableButton extends React.PureComponent {
  constructor() {
    super();
    this.toggleModule = this.toggleModule.bind(this);
  }

  toggleModule(el, props) {
    let module = document.getElementById(el.replace(/\s/g, "").toLowerCase() + "ModuleWrapper");
    let buttonElement = document.getElementById(el + "Button");
    let display = module.className.indexOf("active") > -1;
    let filteredArray = [];

    function changePrefArr() {
      // add/remove toggled element to preferences array
      // console.log(el);
      props.commonProps.list.map((pref, index) => {
        if (pref.name === el) {
          filteredArray.push({
            id: index + 1,
            displayName: pref.displayName,
            name: el,
            active: !display
          });
        } else {
          filteredArray.push(pref);
        }
      });

      props.commonProps.onButtonChange(filteredArray);
    }

    if (display === false) {
      module.classList.add("active");
      buttonElement.classList.remove("inActive");
      changePrefArr();
    } else {
      let testArray = props.commonProps.list.filter((pref) => pref.active);

      if (testArray.length > 1) {
        module.classList.remove("active");
        buttonElement.classList.add("inActive");
        changePrefArr();
      }
    }
  }

  render() {
    const myIndex = this.props.commonProps.list.findIndex((li) => li === this.props.item);
    const { dragHandleProps } = this.props;
    let active = "";
    if (!this.props.item.active) {
      active = " inActive";
    }
    return (
      <div
        id={this.props.item.name + "Button"}
        className={"draggable-button" + active}
        style={{
          transform: "rotate(" + this.props.itemSelected * 3 + "deg)"
        }}
        data-testid="button-container"
      >
        <div className="draggable-button__inner" {...dragHandleProps}>
          <span
            className="order-number"
            onClick={() => this.toggleModule(this.props.item.name, this.props)}
            data-testid="order-number"
          >
            <span className="number">{myIndex + 1}</span>
          </span>
          <span className="title" data-testid="title">
            {this.props.item.displayName}
          </span>
        </div>
      </div>
    );
  }
}

DraggableButton.propTypes = {
  commonProps: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        displayName: PropTypes.string,
        id: PropTypes.number
      })
    )
  }),
  item: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    id: PropTypes.number
  }),
  itemSelected: PropTypes.number,
  dragHandleProps: PropTypes.object,
  onMouseDown: PropTypes.func
};
